import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  Row,
  Typography,
  message,
} from "antd";
import { FC, useState } from "react";
import axios from "axios";

const { Title } = Typography;

const SMSRegisterForm: FC<{
  setSMSToken: any;
  setIsSMSModalOpen: any;
  setRemainingCredits: any;
  displayContactUsModal: any;
  showConfirmForm: any;
  setShowConfirmForm: any;
  onSMSConfirmed: any;
}> = ({
  setSMSToken,
  setIsSMSModalOpen,
  setRemainingCredits,
  displayContactUsModal,
  showConfirmForm,
  setShowConfirmForm,
  onSMSConfirmed,
}) => {
    const [registerForm] = Form.useForm();
    const [connectForm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [phone, setPhone] = useState("");

    const handleRegister = async (values: any) => {
      try {
        setIsLoading(true);
        setPhone(values.phone_number); // Save the phone number for <SMSConfirmForm>

        const response = await axios.post(
          "https://melcarnebackend.digipulse.ch/request_challenge",
          values
        );

        if (response.status === 200) {
          message.success("Challenge request successful!");
          setShowConfirmForm(true); // Show the SMSConfirmForm
        } else {
          throw new Error("Unexpected response");
        }
      } catch (error: any) {
        console.error(error);
        message.error("Une erreur est survenue. Veuillez réessayer.");
      } finally {
        setIsLoading(false);
      }
    };

    const handleConnect = async (values: any) => {
      try {
        setIsLoading(true);
        setPhone(values.phone_number_return); // Save the phone number for <SMSConfirmForm>

        const response = await axios.post(
          "https://melcarnebackend.digipulse.ch/request_challenge",
          {
            phone_number: values.phone_number_return,
          }
        );

        if (response.status === 200) {
          message.success("Challenge request successful!");
          setShowConfirmForm(true); // Show the SMSConfirmForm
        } else {
          throw new Error("Unexpected response");
        }
      } catch (error: any) {
        console.error(error);
        message.error("Une erreur est survenue. Veuillez réessayer.");
      } finally {
        setIsLoading(false);
      }
    };

    return showConfirmForm ? (
      <SMSConfirmForm
        phone={phone}
        setSMSToken={setSMSToken}
        setIsSMSModalOpen={setIsSMSModalOpen}
        setRemainingCredits={setRemainingCredits}
        displayContactUsModal={displayContactUsModal}
        onSMSConfirmed={onSMSConfirmed}
      />
    ) : (
      <>
        <Divider style={{ marginTop: 12, marginBottom: 16 }} />
        <Collapse accordion
          defaultActiveKey={"1"}
          items={[
            {
              key: '1',
              label: "M'inscrire pour obtenir plus d'infos",
              children:
                <Form
                  form={registerForm}
                  layout="vertical"
                  onFinish={handleRegister}
                  style={{ maxWidth: 600, margin: "0 auto" }}
                >
                  <Row gutter={[16, 0]}>
                    <Col span={12}>
                      <Form.Item
                        label="Prénom"
                        name="first_name"
                        rules={[
                          { required: true, message: "Veuillez entrer votre prénom" },
                        ]}
                      >
                        <Input placeholder="Prénom" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Nom"
                        name="last_name"
                        rules={[{ required: true, message: "Veuillez entrer votre nom" }]}
                      >
                        <Input placeholder="Nom" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Téléphone"
                        name="phone_number"
                        rules={[
                          { required: true, message: "Veuillez entrer votre téléphone" },
                          {
                            pattern: /^[0-9]{10}$/,
                            message: "Numéro de téléphone invalide",
                          },
                        ]}
                      >
                        <Input placeholder="Téléphone" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="E-mail"
                        name="email"
                        rules={[
                          { required: true, message: "Veuillez entrer votre e-mail" },
                          { type: "email", message: "Adresse e-mail invalide" },
                        ]}
                      >
                        <Input placeholder="E-mail" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item name="is_owner_of_property" valuePropName="checked">
                        <Checkbox>Êtes-vous propriétaire ?</Checkbox>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="Adresse"
                        name="address"
                        rules={[
                          { required: true, message: "Veuillez entrer votre adresse" },
                        ]}
                      >
                        <Input placeholder="Adresse" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Commune"
                        name="city"
                        rules={[
                          { required: true, message: "Veuillez entrer votre commune" },
                        ]}
                      >
                        <Input placeholder="Commune" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Code postal"
                        name="post_code"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez entrer votre code postal",
                          },
                          { pattern: /^[0-9]{4,5}$/, message: "Code postal invalide" },
                        ]}
                      >
                        <Input placeholder="Code postal" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item style={{ textAlign: "center", marginTop: "20px" }}>
                    <Button type="primary" htmlType="submit" loading={isLoading}>
                      M'inscrire
                    </Button>
                  </Form.Item>
                </Form>
            },
            {
              key: "2",
              label: "Ce n'est pas ma première visite",
              children:        <Form
              form={connectForm}
              layout="vertical"
              onFinish={handleConnect}
              style={{ maxWidth: 600, margin: "0 auto" }}
            >
              <div
                style={{ display: "flex", width: "100%", justifyContent: "center" }}
              >
                <div style={{ width: "100%" }}>
                  <Form.Item
                    label="Téléphone"
                    name="phone_number_return"
                    rules={[
                      { required: true, message: "Veuillez entrer votre téléphone" },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Numéro de téléphone invalide",
                      },
                    ]}
                  >
                    <Input placeholder="Téléphone" />
                  </Form.Item>
                </div>
              </div>
    
              <Form.Item style={{ textAlign: "center", marginTop: "20px" }}>
                <Button type="primary" htmlType="submit" loading={isLoading}>
                  Me connecter
                </Button>
              </Form.Item>
            </Form>
            }
          ]}
        />


      </>
    );
  };

const SMSConfirmForm: FC<{
  phone: string;
  setSMSToken: any;
  setIsSMSModalOpen: any;
  setRemainingCredits: any;
  displayContactUsModal: any;
  onSMSConfirmed: any;
}> = ({
  phone,
  setSMSToken,
  setIsSMSModalOpen,
  setRemainingCredits,
  displayContactUsModal,
  onSMSConfirmed,
}) => {
    const [challenge, setChallenge] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
      if (!challenge) {
        message.warning("Veuillez entrer le code de confirmation.");
        return;
      }

      try {
        setIsLoading(true);
        const response = await axios.get(
          `https://melcarnebackend.digipulse.ch/confirm_challenge`,
          {
            params: {
              phone_number: phone,
              challenge,
            },
          }
        );

        if (response.status === 200 && response.data.token) {
          message.success("Code validé avec succès !");
          console.log("SMS Token: ", response.data.token);

          setSMSToken(response.data.token); // Save the token
          localStorage.setItem("x-sms-token", response.data.token);
          

          setRemainingCredits(response.data.remainingCredits);
          setIsSMSModalOpen(false); // Close the modal

          onSMSConfirmed();
        } else {
          throw new Error("Invalid response");
        }
      } catch (error: any) {
        if (error.response?.data?.message === "NOT_ENOUGH_CREDIT") {
          displayContactUsModal();
        }

        console.error(error);
        message.error(
          error.response?.data?.message || "Code invalide. Veuillez réessayer."
        );
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Typography.Title level={4}>Confirmation par SMS</Typography.Title>
        <p>
          Un code a été envoyé à votre numéro <strong>{phone}</strong>. Veuillez
          le saisir pour continuer.
        </p>
        <Input
          placeholder="Entrez le code de confirmation"
          value={challenge}
          onChange={(e) => setChallenge(e.target.value)}
          maxLength={6}
          style={{ width: 200, margin: "20px auto", display: "block" }}
        />
        <Button
          type="primary"
          onClick={handleConfirm}
          loading={isLoading}
          style={{ marginTop: "10px" }}
        >
          Valider
        </Button>
      </div>
    );
  };

export default SMSRegisterForm;
